var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWidgets = function SvgWidgets(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.85 24.575 23.425 14.15 33.85 3.725 44.275 14.15zm-27.55-3.5V6.35h14.725v14.725zM26.925 41.7V26.95h14.75V41.7zM6.3 41.7V26.975h14.725V41.7zm2.875-23.5h8.975V9.225H9.175zM34 20.7l6.4-6.4L34 7.9l-6.4 6.4zm-4.2 18.125h9v-9h-9zm-20.625 0h8.975V29.85H9.175z"
  })));
};
export default SvgWidgets;